import { SidebarSection } from './common';
import { useInScopeModel } from '../../actions/framework';
import { ManifestModel } from '../../manifest/model/manifest.model';
import {
  DevModeStatus,
  useDevModeStatus,
} from '@cotera/client/app/features/dev-mode';
import { useTabManager } from '../../tab-manager/tab-manager';
import { Routes } from '../../routes';
import { SideBarSection } from './types';

export const Definitions: React.FC = () => {
  const devModeStatus = useDevModeStatus();
  const tabManager = useTabManager();

  const manifestModel = useInScopeModel(ManifestModel);

  const definitionSection: SideBarSection = {
    title: 'Definitions',
    items: Object.entries(manifestModel.manifestInfo.definitions).map(
      ([definitionId, { displayName }]) => ({
        t: 'item',
        title: displayName,
        icon: 'variable',
        onClick: () => {
          tabManager.push({
            route: Routes.definition.forId(definitionId).toString(),
            title: displayName,
            displayTitle: displayName,
            icon: 'variable',
          });
        },
      })
    ),
    quickActions: [],
  };

  if (devModeStatus === DevModeStatus.On) {
    return <SidebarSection section={definitionSection}></SidebarSection>;
  }

  return null;
};
